const fields_helper = (flds, diff) => {

	if (flds.length && diff)
		flds.map( (f, i) => { if (f['DIFF_'+diff]) flds[i] = {...f, ...f['DIFF_'+diff]}; } )

	return flds
};

export default fields_helper
